import React from 'react';

import { NOT_SET } from '../workforce/assumption/recruitmentStatusCategories';
import RecruitmentStatusLabel from '../workforce/assumption/RecruitmentStatusLabel';

/**
 * A row's recruitment status, set in place. Offers Not set, the active statuses and the
 * row's own status even when it has since been made inactive. `mixed` is a group whose
 * members differ: the select is blank until a status is chosen for all of them.
 *
 * Read-only rows get the plain label instead.
 */
export default function RecruitmentStatusSelect({ status, statuses, mixed = false, editable, disabled, onChange }) {
    if (!editable) {
        return mixed ? <span className="tw-text-charcoal-75">{$t('Mixed')}</span> : <RecruitmentStatusLabel status={status} />;
    }

    const options = statuses.filter((option) => option.is_active || option.id === status?.id);
    if (status && !options.some((option) => option.id === status.id)) {
        options.push(status);
    }

    const value = mixed ? '' : status ? String(status.id) : NOT_SET;

    return (
        <select
            aria-label={$t('Recruitment status')}
            className="tw-h-6 tw-w-auto tw-max-w-[12rem] tw-cursor-pointer tw-rounded tw-border-0 tw-bg-transparent tw-py-0 tw-ps-1 tw-pe-6 tw-text-xs tw-text-charcoal focus:tw-ring-2 focus:tw-ring-blue-25"
            value={value}
            disabled={disabled}
            onChange={(e) => onChange(e.target.value === NOT_SET ? null : Number(e.target.value))}
        >
            {mixed && (
                <option value="" disabled>
                    {$t('Mixed')}
                </option>
            )}
            <option value={NOT_SET}>{$t('Not set')}</option>
            {options.map((option) => (
                <option value={option.id} key={option.id}>
                    {option.name}
                </option>
            ))}
        </select>
    );
}
